import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { getReportHeader } from '@/services/report'
import { useAppSelector } from '@/utils/hooks'

import ornament from '~/assets/images/report/banner-ornament.png'

const Banner: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const { data: reportBanner } = useAppSelector(
    getReportHeader.select({
      headers: { 'Accept-Language': String(router.locale) },
    })
  )

  return (
    <div className='relative h-[150px] w-full overflow-hidden lg:h-full'>
      <div className='absolute inset-0 z-0 h-full'>
        <div className='absolute inset-0 z-10 bg-red mix-blend-screen' />
        <div className='absolute inset-0 z-20 bg-black/20' />
        {reportBanner?.data.imageFiles && (
          <ImageByWidthDevice
            images={reportBanner?.data.imageFiles}
            alt='background image'
            className='h-full w-full object-cover object-center'
          />
        )}
      </div>

      <img
        src={ornament.src}
        alt='banner ornament'
        className='absolute -right-[450px] -top-[100px]'
      />

      <div className='container relative z-20 flex h-full flex-col items-center justify-center gap-[5px] text-white lg:py-25'>
        <p className='text-sm font-bold leading-normal lg:text-sm'>{t('report:banner.title')}</p>
        <p className='text-2xl font-bold leading-normal lg:text-4xl'>{t('report:title')}</p>
      </div>
    </div>
  )
}

export default Banner
